"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateFeatures = void 0;
const fp = require("fp-ts");
const translation_1 = require("./translation");
const validation_1 = require("./validation");
function getFeature(features, grant) {
    return features
        .reduce((acc, feature) => {
        if (feature.perm & grant) {
            acc.push((0, translation_1.getLocalization)(`features/${feature.constant}/name`));
        }
        return acc;
    }, [])
        .join(', ');
}
function getRequiredfeatured(required, grant) {
    return required ^ (required & grant);
}
function validateFeatures(features) {
    const grant = features.reduce((acc, feature) => {
        if (feature.enabled) {
            return acc | feature.perm;
        }
        return acc;
    }, 0x00);
    const validaitonErrors = [];
    for (const feature of features) {
        if (feature.enabled &&
            (feature.required > 0x00 || feature.optionals > 0x00)) {
            const requiredGrant = getRequiredfeatured(feature.required, grant);
            const featureText = (0, translation_1.getLocalization)(`features/${feature.constant}/name`);
            if (requiredGrant !== 0x00) {
                const missingFeatures = getFeature(features, requiredGrant);
                validaitonErrors.push({
                    key: 'features',
                    value: (0, translation_1.getLocalization)('validation/error/requiredFeatures', [
                        featureText,
                        missingFeatures
                    ])
                });
            }
            const optionalGrant = getRequiredfeatured(feature.optionals, grant);
            if (feature.optionals !== 0 &&
                (optionalGrant & feature.optionals) === feature.optionals) {
                const missingFeatures = getFeature(features, optionalGrant);
                validaitonErrors.push({
                    key: 'features',
                    value: (0, translation_1.getLocalization)('validation/error/optionalFeatures', [
                        featureText,
                        missingFeatures
                    ])
                });
            }
        }
    }
    if (validaitonErrors.length > 0) {
        return fp.validation.failure(validaitonErrors);
    }
    return fp.validation.success(validation_1.success);
}
exports.validateFeatures = validateFeatures;
//# sourceMappingURL=features.js.map